import React from "react";

export default function Search() {
  return (
    <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_931_9592)">
        <g clip-path="url(#clip0_931_9592)">
          <rect x="1" width="40" height="40" rx="12" fill="url(#paint0_linear_931_9592)" />
          <g clip-path="url(#clip1_931_9592)" filter="url(#filter1_dd_931_9592)">
            <path d="M27.9 24.776C29.4965 22.6424 30.2255 19.9832 29.9403 17.3338C29.6551 14.6843 28.3767 12.2412 26.3627 10.4963C24.3486 8.75147 21.7483 7.83435 19.0852 7.92959C16.4221 8.02483 13.894 9.12537 12.0097 11.0097C10.1254 12.894 9.02483 15.4221 8.92959 18.0852C8.83435 20.7483 9.75147 23.3486 11.4963 25.3627C13.2412 27.3767 15.6843 28.6551 18.3338 28.9403C20.9832 29.2255 23.6424 28.4965 25.776 26.9L30.876 32L33 29.88L27.9 24.776ZM19.5 26C18.0166 26 16.5666 25.5601 15.3332 24.736C14.0999 23.9119 13.1386 22.7406 12.5709 21.3701C12.0032 19.9997 11.8547 18.4917 12.1441 17.0368C12.4335 15.582 13.1478 14.2456 14.1967 13.1967C15.2456 12.1478 16.582 11.4335 18.0368 11.1441C19.4917 10.8547 20.9997 11.0032 22.3701 11.5709C23.7406 12.1386 24.9119 13.0999 25.736 14.3332C26.5601 15.5666 27 17.0166 27 18.5C26.9981 20.4886 26.2074 22.3951 24.8013 23.8013C23.3951 25.2074 21.4886 25.9981 19.5 26Z" fill="url(#paint1_linear_931_9592)" />
          </g>
        </g>
      </g>
      <defs>
        <filter id="filter0_di_931_9592" x="0.5" y="0" width="41" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_931_9592" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_931_9592" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_931_9592" />
        </filter>
        <filter id="filter1_dd_931_9592" x="-21" y="-18.1015" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_931_9592" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3.89851" />
          <feGaussianBlur stdDeviation="15" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_931_9592" result="effect2_dropShadow_931_9592" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_931_9592" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_931_9592" x1="21" y1="0" x2="21" y2="40" gradientUnits="userSpaceOnUse">
          <stop stop-color="#29282C" />
          <stop offset="1" stop-color="#100F11" />
        </linearGradient>
        <linearGradient id="paint1_linear_931_9592" x1="8.73682" y1="2.97579" x2="26.2151" y2="28.5946" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0.65" />
        </linearGradient>
        <clipPath id="clip0_931_9592">
          <rect x="1" width="40" height="40" rx="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_931_9592">
          <rect width="24" height="24" fill="white" transform="translate(9 8)" />
        </clipPath>
      </defs>
    </svg>

  )
}